/* Won't Miss Garage forms v0.1.0
   Generic handler for Shopify contact forms that also post a row to the Google Sheet.
   Mark the field container with data-wmg-sheet-form, data-type and data-tab (see sections/source-import-form.liquid).
   Optional data-pay-amount collects a deposit in the payment popup before the row is sent. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};
  var cfg = WMG.config || {};

  function absolute(path) { try { return new URL(path, window.location.origin).href; } catch (e) { return path; } }

  /* A successful Shopify post re-renders the section with the success block, so any remembered payment is done. */
  if (document.querySelector('.wmg-order__success')) {
    try {
      Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf('wmg_paid_') === 0) sessionStorage.removeItem(k); });
    } catch (e) {}
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-wmg-sheet-form]')).forEach(function (box) {
    var form = box.closest('form');
    if (!form) return;
    var type = box.getAttribute('data-type') || 'contact';
    var tab = box.getAttribute('data-tab') || '';
    var payAmount = Number(box.getAttribute('data-pay-amount')) || 0;
    var payDesc = box.getAttribute('data-pay-description') || 'Deposit';
    var PAID_KEY = 'wmg_paid_' + type;
    var errorEl = form.querySelector('[data-wmg-form-error]');
    var submitBtn = form.querySelector('[data-wmg-submit]');
    var submitLabel = form.querySelector('[data-wmg-submit-label]');
    var busy = false;

    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = !msg; } }
    function setBusy(state, label) { busy = state; if (submitBtn) submitBtn.classList.toggle('is-busy', state); if (submitLabel && label) submitLabel.textContent = label; }
    function setHidden(name, value) { var h = form.querySelector('[data-hidden="' + name + '"]'); if (h) h.value = value == null ? '' : String(value); }
    function setPrefill(name, value) { var f = form.querySelector('[data-prefill="' + name + '"]'); if (f && value != null && value !== '' && !f.value) f.value = value; }
    function readPaid() { try { return JSON.parse(sessionStorage.getItem(PAID_KEY) || 'null'); } catch (e) { return null; } }
    function writePaid(v) { try { v ? sessionStorage.setItem(PAID_KEY, JSON.stringify(v)) : sessionStorage.removeItem(PAID_KEY); } catch (e) {} }

    /* ---------- prefill from ?product=<handle> or ?url=<link> ---------- */
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('product');
    var link = params.get('url');
    if (link) {
      if (/^https?:\/\//i.test(link)) setPrefill('url', link); else setPrefill('title', link);
    }
    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
        .then(function (p) {
          setPrefill('title', p.title);
          setPrefill('url', absolute('/products/' + p.handle));
          setPrefill('handle', p.handle);
          setPrefill('price', (p.price / 100).toFixed(2));
          var box = form.querySelector('[data-wmg-prefill]');
          if (box) {
            var t = box.querySelector('[data-wmg-prefill-title]');
            var pr = box.querySelector('[data-wmg-prefill-price]');
            var m = box.querySelector('[data-wmg-prefill-media]');
            if (t) t.textContent = p.title;
            if (pr) pr.textContent = 'Estimated ' + WMG.money(p.price);
            var img = p.featured_image || (p.images && p.images[0]);
            if (m && img) { var i = document.createElement('img'); i.src = img; i.alt = ''; m.appendChild(i); }
            box.hidden = false;
          }
        }).catch(function () {});
    }

    /* ---------- submit ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!form.reportValidity()) return;
      showError('');
      var label = submitLabel ? submitLabel.textContent : '';
      setBusy(true, payAmount > 0 ? 'Opening payment' : 'Sending');

      var stored = readPaid();
      var payment;
      if (payAmount > 0 && window.WMGPay && window.WMGPay.provider() !== 'none') {
        payment = stored ? Promise.resolve(stored) : window.WMGPay.start({ amount: payAmount, currency: cfg.currency || 'USD', description: payDesc })
          .then(function (res) { res.amount = payAmount; writePaid(res); return res; });
      } else {
        payment = Promise.resolve(null);
      }

      payment.then(function (res) {
        if (res) {
          setHidden('pay_provider', res.provider);
          setHidden('pay_id', res.id);
          setHidden('pay_status', res.status);
          setHidden('paid', (res.status === 'NOT_COLLECTED' ? 0 : res.amount).toFixed(2));
        }
        setBusy(true, 'Sending');
        var payload = WMG.formData(form);
        payload.type = type;
        if (tab) payload.tab = tab;
        return window.WMGSheets ? window.WMGSheets.send(payload) : Promise.resolve('blocked');
      }).then(function (status) {
        setHidden('sheet_status', status);
        HTMLFormElement.prototype.submit.call(form);
      }).catch(function (err) {
        setBusy(false, label);
        showError(err && err.message ? err.message : 'Something went wrong. Nothing was sent.');
      });
    });
  });
})();
